import axios, {
  type InternalAxiosRequestConfig,
  type AxiosResponse,
} from 'axios';

import cancelQueue from '../cancelQueue';

export function cancelQueueRequestInterceptor(
  config: InternalAxiosRequestConfig
) {
  if (!config.cancellable) {
    return config;
  }

  const source = axios.CancelToken.source();

  cancelQueue.add(source);

  return {
    cancelToken: source.token,
    ...config,
  };
}

export function cancelQueueResponseInterceptor(response: AxiosResponse) {
  const {
    config: { cancelToken },
  } = response;

  if (cancelToken) {
    cancelQueue.clear(cancelToken);
  }

  return response;
}
